<script>
  export default {
    props: {},
    data() {
      return {}
    },
    methods: {},
    computed: {},
    watch: {},
    components: {},
    mounted() {
    },
    destroyed() {
    }
  }
</script>
<template>
  <div class="header">
    <div class="wrap">
      <div class="header__phone">+7 (495) 6-020-020</div>
    </div>
  </div>
</template>